<script setup lang="ts">
defineSlice({
  name: { label: 'Blog Index', group: 'Blog', layouts: ['*'] },
  slots: [{ name: 'default', allowedElements: [] }],
  description: '',
  preview: 'SlicesBlogIndex.jpg',
  fields: {

  },
  templates: [{
    label: 'Main Example',
    fields: {

    },
  }],
})

const articles = await queryContent('articles').find()
</script>

<template>
  <div>
    <div class="pt-1 pb-20 text-white">
      <div class="mx-auto max-w-7xl sm:px-6 lg:px-8 pb-12">
        <div class="mx-auto mt-16 grid max-w-2xl auto-rows-fr grid-cols-1 gap-8 sm:mt-20 lg:mx-0 lg:max-w-none lg:grid-cols-3 ">
          <article v-for="blog in articles" :key="blog.id" class="group relative isolate flex flex-col justify-end overflow-hidden border border-stone-800 will-change-transform hover:-translate-y-2 duration-1000 ease-out">
            <div class="w-full aspect-square overflow-hidden">
              <img :src="blog.image" alt="" class="h-full w-full object-cover group-hover:scale-110 duration-1000 ease-out">
            </div>
            <h3 class="text-2xl font-lbm-serif leading-6 text-white p-4 h-40">
              <div>{{ blog.title }}</div>
              <div class="pt-2 font-lbm-sans text-sm text-neutral-400 font-light line-clamp-2">
                {{ blog.description }}
              </div>
              <div>
                <NuxtLink :to="blog._path" class="font-lbm-sans text-xs uppercase font-bold text-lbm-primary">
                  Read more
                </NuxtLink>
              </div>
            </h3>
            <NuxtLink :to="blog._path" class="absolute inset-0" />
          </article>
        </div>
      </div>
    </div>
  </div>
</template>
